/**
 * Which "page" a route is, for analytics and the browser tab.
 *
 * Nearly the whole app is ReaderPage on "/", with the surface held in the
 * query (?panel, ?tab, ?studio, ?reader, ?reading). GA files every one of
 * those under "/" unless we name them, so this maps a route to a virtual
 * path and a title. Pure: no window, no store.
 *
 *   virtualPage({ path: '/', query: { panel: 'altar', tab: 'journal' } })
 *     → { path: '/altar/journal', title: 'Altar · Journal' }
 */
const ALTAR_TABS = { journal: 'Journal', mirror: 'Mirror', seekers: 'Mirror' }
const COMMUNITY_TABS = { mystics: 'Mystics', fireside: 'Fireside', voice: 'Voice' }
const SLUG_OK = /^[a-z0-9][a-z0-9_-]{0,63}$/i

function slug(v) {
  const s = Array.isArray(v) ? v[0] : v
  return s && SLUG_OK.test(String(s)) ? String(s).toLowerCase() : ''
}

function titleCase(s) {
  return s.replace(/[_-]+/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
}

export function virtualPage(route) {
  const path = (route && route.path) || '/'
  const q = (route && route.query) || {}
  const params = (route && route.params) || {}

  if (path.startsWith('/reset-password')) return { path: '/reset-password', title: 'Reset password' }
  // /onboarding, /marketplace and /studio are redirects now (BUILD-DECISIONS 13):
  // the Studio's page views come from the in-app panel below.
  if (path.startsWith('/seeker/')) {
    const nick = slug(params.nickName) || 'seeker'
    return params.readingId
      ? { path: `/seeker/${nick}/reading`, title: 'Seeker · Reading' }
      : { path: `/seeker/${nick}`, title: 'Seeker' }
  }

  const panel = slug(q.panel)
  if (panel === 'altar') {
    const tab = ALTAR_TABS[slug(q.tab)]
    return tab
      ? { path: `/altar/${tab.toLowerCase()}`, title: `Altar · ${tab}` }
      : { path: '/altar', title: 'Altar' }
  }
  if (panel === 'community') {
    const key = COMMUNITY_TABS[slug(q.tab)] ? slug(q.tab) : 'mystics'
    return { path: `/community/${key}`, title: `Community · ${COMMUNITY_TABS[key]}` }
  }
  if (panel === 'quest') return { path: '/quest', title: 'Quest' }
  if (panel === 'studio') {
    const tab = slug(q.studio)
    return tab ? { path: `/studio/${tab}`, title: `Studio · ${titleCase(tab)}` } : { path: '/studio', title: 'Studio' }
  }

  const reader = slug(params.subdomain) || slug(q.reader)
  if (reader) {
    return q.reading
      ? { path: `/reader/${reader}/reading`, title: 'Reading' }
      : { path: `/reader/${reader}`, title: 'Mystic' }
  }
  if (q.reading) return { path: '/reading', title: 'Shared reading' }
  return { path: '/', title: 'Home' }
}

export const SITE_NAME = 'Mystic AIda'

export function documentTitle(page) {
  return page && page.path !== '/' ? `${page.title} – ${SITE_NAME}` : SITE_NAME
}
